import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";

import { SuccessPanel } from "../../../components/Panel/src/InfoPanel";
import { useTrack } from "../../../components/WithTrack/src/useTrack";
import { useTranslation } from "../../../components/WithTranslation/src/I18n";

import { Flex, FlexSpaceBetween } from "./StyledComponents";

const Icon = styled(SWReactIcons)`
    margin-right: 8px;
    width: 1em;
    height: 1.2em;
    path {
        fill: ${colorsPalettes.green["400"]};
    }
`;

const StyledFlex = styled(Flex)`
    color: #4fbf40;
`;

interface ILeadingFoldersSuccessInfoPanel {
    gotItButtonClick?: () => void;
    domain: string;
}
export const LeadingFoldersSuccessInfoPanel = ({ gotItButtonClick, domain }: ILeadingFoldersSuccessInfoPanel) => {
    const [track] = useTrack();
    const translate = useTranslation();

    const gotItButtonClickInternal = () => {
        gotItButtonClick();
        track("got it", "click", `Website Analysis/Leading Folder/${domain}`);
    };

    return (
        <SuccessPanel>
            <FlexSpaceBetween>
                <StyledFlex>
                    <Icon iconName={"checked"} />
                    <span>{translate("website.analysis.leading.folders.info.panel.success.text")}</span>
                </StyledFlex>
                <Button
                    type={"flat"}
                    onClick={gotItButtonClickInternal}
                >
                    {translate("website.analysis.leading.folders.info.panel.success.button")}
                </Button>
            </FlexSpaceBetween>
        </SuccessPanel>
    );
};
